import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import RenderLoading from '../RenderLoading/RenderLoading';
import {checkstate} from '../../service/service.supersalud';

const LoginClaveUnica = (props) => {
    let location = useLocation();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const { user, userLoggedIn } = props;


    const getState = async (state,code) => {
        try {
            setLoading(true);
            var raw = JSON.stringify({"state":state,"code":code});

            const resp = await checkstate()(raw)
            const resp_status = await resp.status;
             setLoading(false);
            if (resp_status === 200) {
                const data = await resp.json();
                userLoggedIn(data["user"]);
                return history.push("/listreclamo");
            }else{
                return history.push("/login?claveunicaMessage=true"); 
            }  
           
        } catch (error) {
            setLoading(false);
        }
    }
    useEffect(() => {
        var searchParams = new URLSearchParams(location.search);
        const code = searchParams.get("code");
        const state = searchParams.get("state");
        if (!user && state && code){
            getState(state,code);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user,location])
    return (
        <div>
            {
                loading?<RenderLoading/>:null
            }
        </div>
    )
}

export default LoginClaveUnica;
